import { metricsChartValueGenerator } from "./metricsChartValueGenerator";
import { MetricType } from "../../../cells/metrics-cells/utils/types";
import { getMetricsByType } from "../../../cells/metrics-cells/utils/helpers/getMetricsByType";
import { ConvertorFnsType } from "../types";
import { MetricsFrequenciesKeysType } from "../../types/metricsFrequenciesType";
import {
  ComputeInlineMetrics,
  DatabaseInlineMetrics,
  DataStorageInlineMetrics,
} from "../../../../../../../../../../../../services/cloudchipr.api";

export const getMetricsGeneratorFn = (
  type: MetricType,
  frequencyKey: MetricsFrequenciesKeysType,
  option: "min" | "max" | "sum",
): ConvertorFnsType => {
  return (key, resource, options) => {
    const { metricsFrequencies } = options ?? {};
    const duration = metricsFrequencies?.[frequencyKey] ?? "";
    const data = (
      key in resource ? resource[key] : undefined
    ) as MetricDataType;

    if (!data) {
      return "N/A";
    }

    const metrics = getMetricsByType(data, type);
    const value = metricsChartValueGenerator(duration, option, metrics);

    if (option === "sum") {
      return value;
    }

    return value === "N/A" ? value : `${value} %`;
  };
};

type MetricDataType =
  | DatabaseInlineMetrics
  | DataStorageInlineMetrics
  | ComputeInlineMetrics
  | undefined;
